import React, { FC, ReactNode } from "react";
import { Theme } from "evcharging/app/themes";
import { css } from "@emotion/css";
import useTheme from "evcharging/hooks/useTheme";

interface RatesWrapperProps {
  children: ReactNode;
}

const RatesWrapper: FC<RatesWrapperProps> = ({ children }) => {
  const theme = useTheme();
  const classes = createStyles(theme);

  return <div className={classes.root}>{children}</div>
}

const createStyles = (theme: Theme) => ({
  root: css({
    backgroundColor: '#F7F8FA',
    overflow: 'hidden',
    '-webkit-overflow-scrolling': 'touch',
  })
});

export default RatesWrapper;
